import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { usePipedriveStore } from '../..';
import useDealsInsideShape from '../../hooks/useDealsInsideShape';
import useDealsWithGlobalFilters from '../../hooks/useDealsWithGlobalFilters';
import useInsightsShape from '../../hooks/useInsightsShape';
import { IDetailsTabProps } from '../../interfaces/IDetailsTabProps';
import DealsGrid from '../deals/DealsGrid';

function InsightsDealsTab({ visible, setEntityCount }: IDetailsTabProps) {
    const pipedriveStore = usePipedriveStore();
    const insightsShape = useInsightsShape();
    const deals = useDealsWithGlobalFilters(useDealsInsideShape(pipedriveStore.deals, insightsShape));

    useEffect(() => setEntityCount(deals.length), [deals]);

    if (!visible || !insightsShape)
        return null;

    return (
        <DealsGrid deals={deals} />
    );
}

export default observer(InsightsDealsTab);